import {
    ISelectedState,
    SelectedActionTypes,
    ChangeBackgroundSelectedActionType,
    ChangeLabelSelectedActionType,
    ChangeInputSelectedActionType,
    ChangeInputValueSelectedActionType,
    ChangeChoicesSelectedActionType,
    ChnageSelectedItemActionType,
} from "./types";
import { Handler } from "./../types/store-types";

const changeBackgroundSelected: Handler<ISelectedState, ChangeBackgroundSelectedActionType> = (state, { payload }) => {
    return {
        ...state,
        isSelectedBackground: payload,
        isLabelSeleced: null,
        isInputSeleced: null,
        isInputValueSeleced: null,
        isChoicesSelected: null,
    };
};

const changeLabelSelected: Handler<ISelectedState, ChangeLabelSelectedActionType> = (state, { payload }) => {
    return {
        ...state,
        isSelectedBackground: false,
        isLabelSeleced: payload,
        isInputSeleced: null,
        isInputValueSeleced: null,
        isChoicesSelected: null,
    };
};

const changeInputSelected: Handler<ISelectedState, ChangeInputSelectedActionType> = (state, { payload }) => {
    return {
        ...state,
        isSelectedBackground: false,
        isLabelSeleced: null,
        isInputSeleced: payload,
        isInputValueSeleced: null,
        isChoicesSelected: null,
    };
};

const changeInputValueSelected: Handler<ISelectedState, ChangeInputValueSelectedActionType> = (state, { payload }) => {
    return {
        ...state,
        isSelectedBackground: false,
        isLabelSeleced: null,
        isInputSeleced: null,
        isInputValueSeleced: payload,
        isChoicesSelected: null,
    };
};

const changeChoicesSelected: Handler<ISelectedState, ChangeChoicesSelectedActionType> = (state, { payload }) => {
    return {
        ...state,
        isSelectedBackground: false,
        isLabelSeleced: null,
        isInputSeleced: null,
        isInputValueSeleced: null,
        isChoicesSelected: payload,
        isCheckboxesSelected: null,
    };
};

const changeSelectedItem: Handler<ISelectedState, ChnageSelectedItemActionType> = (
    state,
    { payload: { item, items } },
) => {
    return {
        ...state,
        item,
        items,
    };
};

export const handlersSelected = {
    [SelectedActionTypes.CHANGE_BACKGROUND_SELECTED]: changeBackgroundSelected,
    [SelectedActionTypes.CHANGE_LABEL_SELECTED]: changeLabelSelected,
    [SelectedActionTypes.CHANGE_INPUT_SELECTED]: changeInputSelected,
    [SelectedActionTypes.CHANGE_INPUT_VALUE_SELECTED]: changeInputValueSelected,
    [SelectedActionTypes.CHANGE_CHOICES_SELECTED]: changeChoicesSelected,

    [SelectedActionTypes.CHANGE_SELECTED_ITEM]: changeSelectedItem,
};
